import { ShieldCheck } from "lucide-react";
import { Reveal } from "@/components/landing/Reveal";
import { EligibilityButton } from "@/components/landing/EligibilityButton";

export const OnlineRiskFree = () => (
  <section className="relative px-4 py-16 sm:px-8 lg:py-20" data-testid="online-riskfree-section">
    <div className="mx-auto max-w-4xl">
      <Reveal>
        <div className="relative overflow-hidden rounded-[2rem] border border-em2/35 bg-surface p-8 text-center glow-emerald sm:p-12">
          <div className="pointer-events-none absolute left-1/2 top-0 h-40 w-96 -translate-x-1/2 rounded-full bg-em1/20 blur-[80px]" />
          <div className="relative z-10">
            <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl border border-em2/30 bg-em2/10 text-em2">
              <ShieldCheck size={26} strokeWidth={1.8} />
            </div>
            <p className="mt-5 text-xs font-bold uppercase tracking-[0.28em] text-gold">
              Risk-Free Start
            </p>
            <h2 className="mt-3 font-display text-4xl font-bold uppercase leading-[0.95] text-offwhite sm:text-5xl">
              Try 2 Live Sessions{" "}
              <span className="text-em2">Before You Commit</span>
            </h2>
            <p className="mx-auto mt-4 max-w-xl text-base leading-relaxed text-mutedgreen">
              Join your first 2 sessions and see exactly how we teach before you
              commit. Your only risk is giving us two sessions.
            </p>
            <div className="mt-7 flex justify-center">
              <EligibilityButton size="lg" label="Claim My Risk-Free Seat" testId="online-riskfree-cta" />
            </div>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
